export const WEBHOOK_EMPTY_MESSAGES = [
    "No hooks in the water yet.",
    "Your systems are waiting to be connected.",
    "Every automation starts with a single webhook.",
    "The silence before the first event fires.",
    "Ready to bridge your apps?",
    "Nothing listening here — yet.",
    "Add a webhook and let the events flow.",
    "Time to connect the dots.",
    "Your integrations are patiently waiting.",
    "No outbound calls configured.",
    "The pipeline is quiet on this end.",
    "Zero webhooks, infinite possibilities.",
];
